import * as React from 'react';
import { Card, Typography } from '@execonline-inc/execonline-ui';
import { T } from '../../Translations';

interface Props {
  error: string;
  onRefresh?: () => void;
}

const FailedState: React.FC<Props> = ({ error, onRefresh }) => {
  return (
    <Card className="w-full pt-6 pr-6 pb-6 pl-6 bg-red-50" radius="lg">
      <div className="flex items-start space-x-3">
        <svg
          className="w-5 h-5 text-red-600 mt-0.5"
          fill="currentColor"
          viewBox="0 0 20 20"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fillRule="evenodd"
            d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z"
            clipRule="evenodd"
          />
        </svg>
        <div className="flex-1">
          <Typography variant="bodySmall" fontWeight="medium" className="text-red-800">
            <T kind="Failed to generate summary" />
          </Typography>
          <Typography variant="bodySmall" className="mt-1 text-red-700">
            {error}
          </Typography>
          {onRefresh && (
            <button
              onClick={onRefresh}
              className="mt-3 text-sm px-3 py-1 bg-red-600 text-white rounded hover:bg-red-700 transition-colors"
            >
              <T kind="Try Again" />
            </button>
          )}
        </div>
      </div>
    </Card>
  );
};

export default FailedState;
